webpackJsonp([267260487189813],{

/***/ 439:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"fields":{"slug":"/test/"},"frontmatter":{"title":"test"}}},{"node":{"fields":{"slug":"/blog/test/"},"frontmatter":{"title":"test"}}}]}},"pathContext":{"tag":"test"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-test-2939982beb541372b647.js